import React, { useState } from 'react'
import PropTypes from 'prop-types'
import MsBHUSingleSiteModal from './component'

export const MsBHUSingleSiteModalContainer = ({
  onModalCancel,
  onModalSave,
  site,
}) => {
  const [bhuUnitEnabled, setBhuUnitEnabled] = useState(
    site?.preferences?.value ?? false,
  )

  const setEnabled = () => setBhuUnitEnabled(true)
  const setDisabled = () => setBhuUnitEnabled(false)

  const handleOnSave = () => {
    const siteUpdate = {
      siteId: site.siteId,
      preferences: [
        {
          ...site.preferences,
          value: bhuUnitEnabled,
        },
      ],
    }
    onModalSave([siteUpdate])
  }

  return (
    <MsBHUSingleSiteModal
      bhuUnitEnabled={bhuUnitEnabled}
      handleOnSave={handleOnSave}
      onModalCancel={onModalCancel}
      setDisabled={setDisabled}
      setEnabled={setEnabled}
      siteName={site.name}
    />
  )
}

MsBHUSingleSiteModalContainer.propTypes = {
  onModalCancel: PropTypes.func,
  onModalSave: PropTypes.func,
  site: PropTypes.shape({
    name: PropTypes.string,
    siteId: PropTypes.number,
    preferences: PropTypes.shape({
      value: PropTypes.bool,
      name: PropTypes.string,
    }),
  }).isRequired,
}

export default MsBHUSingleSiteModalContainer
